var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.625 1.5H6.45C6.15 1.5 5.85 1.65 5.625 1.875C5.4 2.1 5.25 2.4 5.25 2.7V12.3C5.25 12.6 5.4 12.9 5.625 13.125C5.85 13.35 6.15 13.5 6.45 13.5H13.8C14.1 13.5 14.4 13.35 14.625 13.125C14.85 12.9 15 12.6 15 12.3V4.875L11.625 1.5Z",
    stroke: "#65A30D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 5.7002V15.3002C2.25 15.6002 2.4 15.9002 2.625 16.1252C2.85 16.3502 3.15 16.5002 3.45 16.5002H10.8",
    stroke: "#65A30D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 1.5V5.25H15",
    stroke: "#65A30D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiles);
export default __webpack_public_path__ + "static/media/files.19902a563e2ac0ba78fae5275bb0d513.svg";
export { ForwardRef as ReactComponent };